import actions from "./actions";

const {
    FETCH_STUDENT,
    FETCH_STUDENTS,
    FETCH_NEW_STUDENTS,
    RESET_STUDENT,
    FETCH_STUDENT_SUBJECTS,
    FETCH_STUDENT_SUBJECTIVE_ATTENDANCE,
    FETCH_STUDENT_ATTENDANCE,
    FETCH_STUDENT_ATTENDANCE_METRICS,
    FETCH_STUDENT_SUBJECTIVE_ATTENDANCE_METRICS
} = actions;

const initState = {
    students: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    newStudents: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    student: {_id: null},
    subjects: [],
    coordination: null,
    subjectiveAttendance: {
        page: 1,
        perPage: 50,
        data: [],
        total: 0
    },
    classAttendance: {
        page: 1,
        perPage: 50,
        data: [],
        total: 0
    },
    // Metrics initial state
    attendanceMetrics: {
        typeWise: [],
        grandTotal: {
            totalDays: 0,
            presentDays: 0,
            absentDays: 0,
            presentAvg: 0,
            absentAvg: 0
        }
    },
    subjectiveAttendanceMetrics: {
        typeWise: [],
        grandTotal: {
            totalDays: 0,
            presentDays: 0,
            absentDays: 0,
            presentAvg: 0,
            absentAvg: 0
        }
    }
};

const StudentReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_STUDENTS:
            return {
                ...state,
                students: data
            };
        case FETCH_NEW_STUDENTS:
            return {
                ...state,
                newStudents: data
            };
        case RESET_STUDENT:
            return {
                ...state,
                student: initState.student,
                subjects: initState.subjects,
                coordination: initState.coordination,
                subjectiveAttendance: initState.subjectiveAttendance
            };
        case FETCH_STUDENT:
            return {
                ...state,
                student: data,
            };
        case FETCH_STUDENT_SUBJECTS:
            return {
                ...state,
                subjects: data?.subjects || [],
                coordination: data?.coordination || null
            };
        case FETCH_STUDENT_SUBJECTIVE_ATTENDANCE:
            return {
                ...state,
                subjectiveAttendance: data || initState.subjectiveAttendance
            };
        case FETCH_STUDENT_ATTENDANCE:
            return {
                ...state,
                classAttendance: data || initState.classAttendance
            };
        case FETCH_STUDENT_ATTENDANCE_METRICS:
            return {
                ...state,
                attendanceMetrics: data || initState.attendanceMetrics
            };
        case FETCH_STUDENT_SUBJECTIVE_ATTENDANCE_METRICS:
            return {
                ...state,
                subjectiveAttendanceMetrics: data || initState.subjectiveAttendanceMetrics
            };
        default:
            return state;
    }
};

export default StudentReducer;